"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gql = void 0;
const gql = (...parts) => {
    throw new Error('should be replaced by ts transformer');
};
exports.gql = gql;
//# sourceMappingURL=helpers.js.map